module.exports = __webpack_public_path__ + "static/media/gaj.0835df1d.png";